// src/admin/ManageLandingPages.js
import React, { useState, useEffect } from 'react';
import { collection, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../config/firebaseConfig';
import { Link } from 'react-router-dom';
import { Table, Button, Spinner, Alert } from 'react-bootstrap';
import { TrashIcon, PencilSquareIcon, PlusIcon, EyeIcon, ChartBarIcon } from '@heroicons/react/24/outline'; // ChartBarIcon eklendi

const ManageLandingPages = () => {
    const [pages, setPages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        fetchPages();
    }, []);

    const fetchPages = async () => {
        setLoading(true);
        try {
            const querySnapshot = await getDocs(collection(db, 'customPages'));
            const pageList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setPages(pageList);
        } catch (err) {
            setError('Failed to fetch pages.');
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this page? This action cannot be undone.')) {
            try {
                await deleteDoc(doc(db, 'customPages', id));
                setPages(pages.filter(page => page.id !== id));
            } catch (err) {
                setError('Failed to delete page.');
            }
        }
    };

    if (loading) return <div className="text-center mt-5"><Spinner animation="border" /></div>;

    return (
        <div className="container-fluid p-4">
            {/* Üst Menü / Kontrol Alanı */}
            <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
                <h2>Manage Landing Pages</h2>
                <div className="d-flex gap-2">
                    {/* YENİ EKLENEN: İstatistik Sayfasına Geçiş Butonu */}
                    <Link to="/admin/landing-page-analytics" className="btn btn-outline-dark d-flex align-items-center gap-2 rounded shadow-sm">
                        <ChartBarIcon style={{ width: '18px' }} /> Analytics
                    </Link>
                    <Link to="/admin/create-landing-page" className="btn btn-primary d-flex align-items-center gap-2 rounded shadow-sm">
                        <PlusIcon style={{ width: '20px' }} /> Create New Page
                    </Link>
                </div>
            </div>

            {error && <Alert variant="danger">{error}</Alert>}

            <div className="table-responsive bg-white shadow-sm rounded p-3">
                <Table hover className="align-middle">
                    <thead className="table-light">
                        <tr>
                            <th>Page Title</th>
                            <th>Slug</th>
                            <th>Status</th>
                            <th className="text-end">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pages.length === 0 ? (
                            <tr><td colSpan="4" className="text-center text-muted py-4">No landing pages found.</td></tr>
                        ) : (
                            pages.map(page => (
                                <tr key={page.id}>
                                    <td className="fw-bold">{page.title}</td>
                                    <td>/{page.slug}</td>
                                    <td><span className="badge bg-success">Published</span></td>
                                    <td className="text-end">
                                        <a href={`/${page.slug}`} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-info me-2" title="View Live Page">
                                            <EyeIcon style={{ width: '16px' }} /> View
                                        </a>
                                        <Link to={`/admin/edit-landing-page/${page.id}`} className="btn btn-sm btn-outline-primary me-2">
                                            <PencilSquareIcon style={{ width: '16px' }} /> Edit
                                        </Link>
                                        <Button variant="outline-danger" size="sm" onClick={() => handleDelete(page.id)}>
                                            <TrashIcon style={{ width: '16px' }} /> Delete
                                        </Button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </Table>
            </div>
        </div>
    );
};

export default ManageLandingPages;